module.exports = __webpack_public_path__ + "img/shake_shack.f9f09f3b.webp";